import React, { useMemo } from 'react'
import { Grid, Checkbox } from '@material-ui/core'
import { useGetAiGuardrails } from '../../../../../api/denaliAssistant'
import Loading from '../../../../../components/molecules/Loading'
import OpalPresentationTable from '../../../../../components/organisms/DenaliAnalysis/tables/presentation'

const columns = [
  { accessorKey: 'name', header: 'Name', id: 'name', size: 180, minSize: 150 },
  { accessorKey: 'description', header: 'Description', id: 'description', size: 320, minSize: 300 },
  {
    accessorKey: 'enabled',
    header: 'Enabled',
    id: 'enabled',
    size: 100,
    minSize: 100,
    enableResizing: false,
    align: 'center',
    cell: (info) => {
      const enabled = info.getValue()
      return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Checkbox
            checked={Boolean(enabled)}
            disabled
            size='small'
          />
        </div>
      )
    }
  }
]

function GuardrailsList () {
  const { data, isLoading, error } = useGetAiGuardrails()

  const tableData = useMemo(() => {
    return (data?.guardrails || [])
      .filter(guardrail => !guardrail.hidden)
      .map(guardrail => ({
        name: guardrail.name || 'Unnamed',
        description: guardrail.description || '',
        enabled: guardrail.enabled
      }))
  }, [data])

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div>Error loading guardrails: {error.message || 'Unknown error'}</div>
        </Grid>
      </Grid>
    )
  }

  if (!tableData || tableData.length === 0) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div>No guardrails available</div>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <OpalPresentationTable
          columns={columns}
          data={tableData}
          defaultSort={[]}
        />
      </Grid>
    </Grid>
  )
}

export default GuardrailsList
